import type { DatasetFile, EpisodeSummary } from "@/api";

// 우측 미리보기 패널이 그릴 대상.
// - episode: 전체 에피소드 뷰(카메라 그리드 + parquet preview). Episodes 모드 + Files 모드 parquet 채널.
// - channelVideo: 단일 카메라 영상. Files 모드 video 채널 폴더에서 에피소드 선택(channel=카메라 이름).
// - file: 폴더 파일 목록에서 고른 파일 1건. 카탈로그(episode·meta·extra)는 행의 `kind` 가
//   나타낸다. URL 은 `(kind, uuid)` 배치 서명으로 받는다. 편집(이름 변경·삭제)은 `extra` 만 열린다.
export type FolderSelection =
  | { kind: "episode"; episode: EpisodeSummary }
  | { kind: "channelVideo"; episode: EpisodeSummary; channel: string }
  | { kind: "file"; file: DatasetFile }
  | null;

/**
 * 파일 1건을 가리키는 선택인가.
 *
 * extra 파일 write(업로드·이름변경·삭제)가 무효화할 수 있는 선택은 이것뿐이다. 에피소드와 단일
 * 카메라는 에피소드에 귀속되므로 파일이 바뀌어도 유효하다. 이 경우를 넓게 잡으면 write 뒤에
 * 에피소드 선택까지 비워진다. 그러면 라벨링 독이 언마운트되고 미저장 편집이 확인 없이 사라진다.
 */
export function isFileSelection(selection: FolderSelection): boolean {
  return selection !== null && selection.kind === "file";
}
